import { useAction } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { openTransactionDetailsDialogAction } from '@root/entities/transaction/atoms'
import { TransactionHistoryList } from '@root/features/user'
import { ProfileOwner } from '@root/features/user/profile/model/profile-owner'
import { TransactionHistoryListEmpty } from '@root/features/user/transaction-history/ui/transaction-history-list-empty'

import type { DelugeId } from '@root/entities/user-short'

type ProfileTransactionsProps = {
  delugeId?: DelugeId
  profileOwner: ProfileOwner
}
export const ProfileTransactions = ({
  delugeId,
  profileOwner,
}: ProfileTransactionsProps) => {
  const { t } = useTranslation()
  const openTransactionDetailsDialog = useAction(
    openTransactionDetailsDialogAction,
  )

  return (
    <Root>
      <Title>{t('profile.transaction_history')}</Title>
      <TransactionHistoryList
        delugeId={delugeId}
        onOpenTransactionDetails={openTransactionDetailsDialog}
        renderEmptyMessage={() => (
          <TransactionHistoryListEmpty
            transactionsOwner={
              profileOwner === ProfileOwner.CurrentUser ? 'current' : 'another'
            }
          />
        )}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;

  padding-inline-start: 8px;
  padding-block: 0 var(--safe-bottom);
`

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: var(--text-12);

  margin-block: 22px 8px;
`
